import { render, staticRenderFns } from "./goals.vue?vue&type=template&id=d6381fca"
import script from "./goals.vue?vue&type=script&lang=ts"
export * from "./goals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports